import axios from 'axios';

export const API = axios.create({
  baseURL: 'https://api.leths.com/api/v1',
  headers: {
    API_TOKEN: '5d2d683a0dcd1de287c0673c660cc898@d602a5191d0779ed67faca3c8b1ccb23',
    "Content-Type": "application/json"
  }
});
